/* ============================================================
   Michelle Snape theme — interactions
   ============================================================ */
(function () {
  /* ---- nav scroll state + progress ---- */
  var nav = document.getElementById('nav');
  var progress = document.getElementById('progress');
  var onScroll = function () {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
    if (progress) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    }
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---- mobile drawer ---- */
  var burger = document.getElementById('burger');
  var drawer = document.getElementById('drawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.querySelectorAll('[data-close]').forEach(function (a) {
      a.addEventListener('click', function () {
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---- reveal on scroll ---- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in-view');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* ---- gold dust particles in hero ---- */
  var dust = document.getElementById('dust');
  if (dust) {
    for (var i = 0; i < 22; i++) {
      var d = document.createElement('i');
      d.style.left = Math.random() * 100 + '%';
      d.style.top = Math.random() * 100 + '%';
      d.style.animationDelay = (Math.random() * 5).toFixed(2) + 's';
      d.style.transform = 'scale(' + (Math.random() * 1.4 + 0.4).toFixed(2) + ')';
      dust.appendChild(d);
    }
  }
})();
